import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Siren } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents')({
    staticData: {
        breadcrumb: {
            title: 'Incidents',
            inactive: true,
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
        ui: {
            icon: Siren,
            title: 'Incidents',
            useTitleForChildren: true,
            menuDescription: 'Settings, rules, custom fields and flags',
        },
    },
    component: Outlet,
});
